import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleContactClick = () => {
    if (location.pathname !== "/") {
      navigate("/", { replace: false });
      setTimeout(() => {
        const el = document.getElementById("contact");
        el?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } else {
      const el = document.getElementById("contact");
      el?.scrollIntoView({ behavior: "smooth" });
    }
  };

  const [isOpen7, setIsOpen7] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <nav
        className={`font-semibold py-6 px-4 md:px-16 lg:px-32 sticky top-0 z-50 backdrop-blur-lg bg-white/30 ${
          isScrolled ? "shadow-md" : ""
        } transition-shadow duration-300 ease-in-out border-b border-white/30`}
      >
        <div className="container mx-auto flex justify-between items-center">
          <Link to="/" className="text-slate-700 font-bold text-xl">
            Leo Club, University of Delhi
          </Link>

          <div className="hidden md:flex space-x-6">
            <Link to="/" className="text-slate-700 px-3">
              Home
            </Link>
            <Link to="/dhruvtara" className="text-slate-700 px-3">
              Dhruvtara
            </Link>
            <Link to="/parinday" className="text-slate-700 px-3">
              Parindey
            </Link>
            <Link to="/vitt-vichaar" className="text-slate-700 px-3">
              Vitt Vichaar
            </Link>
            <Link to="/team-leo" className="text-slate-700 px-3">
              Team Leo
            </Link>
            {/* <a href="/donate" className="text-slate-700 px-3">
              Donate Us
            </a> */}
          </div>

          <a
            href="#contact"
            onClick={handleContactClick}
            className="hidden md:inline-block bg-[#1D4C60] hover:bg-[#112f3b] hover:ease-in-out transition text-white px-4 py-3 rounded-full"
          >
            Contact Us
          </a>

          <button
            className="md:hidden text-slate-700"
            onClick={() => setIsOpen7(!isOpen7)}
          >
            {isOpen7 ? (
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            ) : (
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            )}
          </button>
        </div>

        <div
          className={`md:hidden mt-4 space-y-2 transition-all duration-300 ease-in-out ${
            isOpen7 ? "opacity-100 max-h-screen" : "opacity-0 max-h-0"
          }`}
        >
          <Link to="/" className="block text-slate-700 px-4 py-2">
            Home
          </Link>
          <Link to="/dhruvtara" className="block text-slate-700 px-4 py-2">
            Dhruvtara
          </Link>
          <Link to="/parinday" className="block text-slate-700 px-4 py-2">
            Parindey
          </Link>
          <Link to="/vitt-vichaar" className="block text-slate-700 px-4 py-2">
            Vitt Vichaar
          </Link>
          <Link to="/team-leo" className="block text-slate-700 px-4 py-2">
            Team Leo
          </Link>
          {/* <a href="/donate" className="block text-slate-700 px-4 py-2">
            Donate Us
          </a> */}
          <a
            href="#contact"
            onClick={handleContactClick}
            className="block text-slate-700 px-4 py-2"
          >
            Contact Us
          </a>
        </div>
      </nav>
    </>
  );
}
